import {
  DataGrid,
  gridPageCountSelector,
  gridPaginationModelSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/CmmTable.module.css";
import Styles from "../Styles/index.module.css";
import {
  Grid,
  TablePagination,
} from "@mui/material";
import Swal from "sweetalert2";
import axios from "axios";
import Loader from "../../../../Loader/Loader";
import { useStateValue } from "../../../../Hooks/stateProvider";
import { CreateColumns } from "./CreateColumns";
import { encrypt } from "../../../../utils/cipher";
import { ls } from "../../../../variables";
import { errorHandler } from "../../../../utils/errorHandling";
import { alert } from "../../../../utils/sweetAlert";


const CmmModule = ({
  data,
  filePayload,
  setIsPreviewClicked,
  setFormResult,
  type,
  handleValidation,
}) => {
console.log("TYPE>>>",type);

  const pmsName = ls.get("pmsName");
  const [rows, setRows] = useState([]);
  const [{ SaveData, pageLoading }, dispatch] = useStateValue();
  const [rowsChanged, setRowChanged] = useState([]);
  const navigate = useNavigate();

  const CustomFooter = ({ onSendClick }) => {
    const apiRef = useGridApiContext();
    // console.log("footer")
    const paginationModel = useGridSelector(
      apiRef,
      gridPaginationModelSelector
    );
    const pageCount = useGridSelector(apiRef, gridPageCountSelector);
    return (
      <Grid
        container
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "52px",
        }}
      >
        <Grid item xs={3}></Grid>

        <Grid item xs={6} sx={{ textAlign: "center" }}>
          <div className={Styles.buttonContainers}>
            <button
              className={Styles.Preview}
              onClick={handleSave}
              sx={{ textAlign: "center", marginRight: "0px !important" }}
            >
              SAVE
            </button>
            <button
              className={Styles.Reset}
              onClick={() => {
                handleReset(handleValidation);
              }}
              sx={{ textAlign: "center", marginRight: "0px !important" }}
            >
              RESET
            </button>
          </div>
        </Grid>
        <Grid item xs={3}>
          <TablePagination
            component="div"
            className="table_pagination"
            count={rows.length}
            page={paginationModel.page}
            onPageChange={(event, value) => apiRef.current.setPage(value)}
            rowsPerPage={paginationModel.pageSize}
            rowsPerPageOptions={[]}
          />
        </Grid>
      </Grid>
    );
  };

  useEffect(() => {
    setRows(data.rows);
  }, [data]);

  const handleSave = async () => {

    let payload;
    if (type === "cmm") {
      payload = {
        pmsName: pmsName,
        fy_year: filePayload.fy_year,
        quarter: filePayload.quarter,
        fileType: "CMM",
        requiredDocuments: Object.values(rowsChanged),
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken"),
      };
    } 
    // else {
    //   payload = {
    //     pmsName: pmsName,
    //     fy_year: filePayload.fy_year,
    //     half_year: filePayload.half_year,
    //     fileType: "HYTR",
    //     requiredDocuments: Object.values(rowsChanged),
    //     authToken: ls.get("authToken"),
    //     refreshToken: ls.get("refreshToken"),
    //   };
    // }
    dispatch({ type: "SHOW_LOADER" });
    const encryptedPayload = await encrypt(payload);
    axios
      .post(
        "api/pms/saveDocument",
        { payload: encryptedPayload }
      )
      .then(async (response) => {
        if (response.data.success) {
          setIsPreviewClicked(true);
          setRowChanged({});
          let payload_preview;
          if (type === "cmm") {
            payload_preview = {
              pmsName: pmsName,
              fy_year: filePayload.fy_year,
              quarter: filePayload.quarter,
              fileType: "CMM",
              authToken: ls.get("authToken"),
              refreshToken: ls.get("refreshToken"),
            };
          }
          //  else {
          //   payload_preview = {
          //     pmsName: pmsName,
          //     fy_year: filePayload.fy_year,
          //     half_year: filePayload.half_year,
          //     fileType: "HYTR",
          //     authToken: ls.get("authToken"),
          //     refreshToken: ls.get("refreshToken"),
          //   };
          // }
          const encryptedPayload = await encrypt(payload_preview);
          axios
            .post(
              "api/pms/previewPage",
              { payload: encryptedPayload }
            )
            .then((response) => {
              let tempObj = {},
                mappedDataArray = [];
              if (type == "cmm") {
                if (response.data.value.length > 0) {
                  response.data.value.map((element, index) => {
                    element.id = index + 1;
                    tempObj[element.cmm_type] = [
                      ...(tempObj[element.cmm_type] || []),
                      element,
                    ];
                  });
                  Object.keys(tempObj).map((ele, index) => {
                    mappedDataArray.push({
                      label: ele,
                      rows: tempObj[ele],
                      columns: CreateColumns(
                        Object.keys(tempObj[ele][0]),
                        ele,
                        type
                      ),
                    });
                  });
                  dispatch({ type: "HIDE_LOADER" });
                  setFormResult(mappedDataArray);
                }
              } else {
                if (response.data.value.length > 0) {
                  response.data.value.map((element, index) => {
                    element.id = index + 1;
                    tempObj["HYTR Module"] = [
                      ...(tempObj["HYTR Module"] || []),
                      element,
                    ];
                  });
                  Object.keys(tempObj).map((ele, index) => {
                    mappedDataArray.push({
                      label: ele,
                      rows: tempObj[ele],
                      columns: CreateColumns(
                        Object.keys(tempObj[ele][0]),
                        ele,
                        type
                      ),
                    });
                  });
                  dispatch({ type: "HIDE_LOADER" });
                  setFormResult(mappedDataArray);
                }
              }
              alert("Data saved", "Data has been saved successfully", "success")
            })
            .catch((err) => {
              console.log("error:", err);
              dispatch({ type: "HIDE_LOADER" });
              errorHandler(err, navigate)
            });
        } else {
          alert("Oops...", "Something went wrong!", "error")
        }
      })
      .catch((err) => {
        console.log("error:", err);
        dispatch({ type: "HIDE_LOADER" });
        errorHandler(err, navigate)
      });
  };

  const handleReset = async (handleValidation) => {
    let payload;
    Swal.fire({
      icon: "warning",
      title: "Are you sure, you want to reset?",
      showCancelButton: true,
      confirmButtonColor: "#154063",
      cancelButtonColor: "#d33",
      cancelButtonText: "No",
      confirmButtonText: "Yes",
    }).then(async (val) => {
      if (type === "cmm") {
        payload = {
          pmsName: pmsName,
          fy_year: filePayload.fy_year,
          period: filePayload.quarter,
          fileType: "CMM",
          authToken: ls.get("authToken"),
          refreshToken: ls.get("refreshToken"),
        };
      } 
      const encryptedPayload = await encrypt(payload);
      if (val.isConfirmed) {
        dispatch({ type: "SHOW_LOADER" });

        axios
          .post(
            "/api/pms/truncateTable",
            { payload: encryptedPayload }
          )
          .then((response) => {
            if (response.data.success) {
              alert("Success", "Your table was successfully reset", "success")
              handleValidation(true);
            } else {
              alert("Oops...", "Something went wrong!", "error")
            }
          })
          .catch((err) => {
            console.log("error:", err);
            dispatch({ type: "HIDE_LOADER" });
            errorHandler(err, navigate)
          });
      }
    });
  };

  const statusPercentage = {
    "Compliant": "100%",
    "Compliant(No Change)":"",
    "Partially Compliant": "",
    "Not Compliant": "0%",
    "Not Applicable": "NA"
  };

  useEffect(() => {
    // console.log("saveData triggered")
    if (type == "cmm") {
      if (SaveData.type == "cmm_remarks") {
        const objIndex = rows.findIndex(
          (obj) => obj.cmm_id === SaveData.object.cmm_id
        );
        if (objIndex !== -1) {
          const updatedRows = [...rows];
          updatedRows[objIndex] = {
            ...updatedRows[objIndex],
            cmm_remarks: SaveData.value,
          };
          setRows(updatedRows);
          setRowChanged({
            ...rowsChanged,
            [updatedRows[objIndex].cmm_id]: updatedRows[objIndex],
          });
        }
      } else if (SaveData.type == "remarks") {
        const objIndex = rows.findIndex(
          (obj) => obj.cmm_id === SaveData.object.cmm_id
        );
        if (objIndex !== -1) {
          const updatedRows = [...rows];
          updatedRows[objIndex] = {
            ...updatedRows[objIndex],
            compliance_status: SaveData.value,
            compliance_percentage: statusPercentage[SaveData.value],
          };
          setRows(updatedRows);
          setRowChanged({
            ...rowsChanged,
            [updatedRows[objIndex].cmm_id]: updatedRows[objIndex],
          });
        }
      } else if (SaveData.type == "percentage") {
        const objIndex = rows.findIndex(
          (obj) => obj.cmm_id === SaveData.object.cmm_id
        );
        if (objIndex !== -1) {
          const updatedRows = [...rows];
          updatedRows[objIndex] = {
            ...updatedRows[objIndex],
            compliance_percentage: SaveData.value + "%",
          };
          setRows(updatedRows);
          setRowChanged({
            ...rowsChanged,
            [updatedRows[objIndex].cmm_id]: updatedRows[objIndex],
          });
        }
      } else {
        const objIndex = rows.findIndex(
          (obj) => obj?.cmm_complaint_id === SaveData?.object?.cmm_complaint_id
        );
        if (objIndex !== -1) {
          const updatedRows = [...rows];
          updatedRows[objIndex] = { ...updatedRows[objIndex] };
          updatedRows[objIndex][SaveData.type] = SaveData.value;
          setRows(updatedRows);
          setRowChanged({
            ...rowsChanged,
            [updatedRows[objIndex]?.cmm_complaint_id]: updatedRows[objIndex],
          });
        }
      }
    } 
  }, [SaveData]);

  return (
    (<div style={{ height: "100%", width: "100%", marginTop: "0%" }}>
      <Loader />
      {/* ) : ( */}
      <DataGrid
        getRowHeight={(params) => "auto"}
        rows={rows}
        columns={data.columns}
        onCellKeyDown={(params, events) => events.stopPropagation()}
        sx={{
          width: "fit-content",
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",
          },
          "& .MuiDataGrid-withBorderColor": {
            borderRight: "none",
          },
          "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
          "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
            display: "none",
          },
          "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
          "& .MuiDataGrid-topContainer": { width: "fit-content" },
          "& .MuiDataGrid-cell": {
            whiteSpace: "normal",
            wordWrap: "break-word",
          },
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "5px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
            py: "8px",
          },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
            py: "15px",
          },
          // "& .MuiDataGrid-main": {
          //     overflow: "unset",
          //   },
        }}
        style={{
          color: "#154063",
          width: "100%",
          whiteSpace: "nowrap",
          height: "100%",
          borderWidth: "2px",
          borderRadius: "10px",
        }}
        rowsPerPageOptions={[2, 5, 10]}
        AutoGenerateColumns={false}
        disableRowSelectionOnClick
        disableColumnMenu
        disableRowCount
        disableColumnSelector
        scrollbarSize={0}
        slots={{
          footer: CustomFooter,
        }}
        footer={{
          render: (params) => <CustomFooter />,
        }}
        autoPageSize
      />
    </div>)
  );
};

export default CmmModule;
